import {
  FiBox,
  FiCreditCard,
  FiHome,
  FiSettings,
  FiUser,
} from "react-icons/fi";
import { useLocation } from "react-router";
import GetLocalStorage from "../../../utils/GlobalUtils/GetLocalStorage";

export const DrawerURLs = () => {
  const location = useLocation();
  const userDetails = GetLocalStorage();

  const URLValues = {
    Urls: [
      {
        icon: <FiHome />,
        name: "Dashboard",
        hasChildren: false,
        href: "/dashboard",
        isDashboard: true,
      },
      ...(userDetails?.userType === "Corporate" || userDetails?.userType === "Agent" ? [{
        icon: <FiCreditCard />,
        name: "Wallet",
        hasChildren: false,
        href: "/dashboard/wallet",
      }] : []),
      ...(userDetails?.userType === "Aggregator" ? [{
        icon: <FiUser />,
        name: "Agency Management",
        hasChildren: true,
        href: "",
        children: [
          {
            name: "Downline",
            href: "/dashboard/agency-management/downline",
          },
          {
            name: "Add Downline",
            href: "/dashboard/agency-management/add-downline",
          },
        ],
      }] : []),
      {
        icon: <FiUser />,
        name: "Agency Banking",
        hasChildren: true,
        href: "",
        children: [
          {
            name: "Fund Wallet",
            href: "/dashboard/agency-banking/fund-wallet",
          },
          {
            name: "Send Money",
            href: "/dashboard/agency-banking/send-money",
          },
        ],
      },
      {
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.5 16C15.6326 16 15.7598 15.9473 15.8536 15.8536C15.9473 15.7598 16 15.6326 16 15.5C16 15.3674 15.9473 15.2402 15.8536 15.1464C15.7598 15.0527 15.6326 15 15.5 15C15.3674 15 15.2402 15.0527 15.1464 15.1464C15.0527 15.2402 15 15.3674 15 15.5C15 15.6326 15.0527 15.7598 15.1464 15.8536C15.2402 15.9473 15.3674 16 15.5 16ZM8.5 9C8.63261 9 8.75979 8.94732 8.85355 8.85355C8.94732 8.75979 9 8.63261 9 8.5C9 8.36739 8.94732 8.24021 8.85355 8.14645C8.75979 8.05268 8.63261 8 8.5 8C8.36739 8 8.24021 8.05268 8.14645 8.14645C8.05268 8.24021 8 8.36739 8 8.5C8 8.63261 8.05268 8.75979 8.14645 8.85355C8.24021 8.94732 8.36739 9 8.5 9Z"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16 8L8 16"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
        name: "Commision",
        hasChildren: false,
        href: "/dashboard/commision",
        isDashboard: true,
      },
      {
        icon: <FiBox />,
        name: "Product",
        hasChildren: true,
        href: "",
        children: [
          {
            name: "Airtime",
            href: "/dashboard/product/buy-airtime",
          },
          {
            name: "Data",
            href: "/dashboard/product/buy-data",
          },
          {
            name: "Electricity",
            href: "/dashboard/product/electricity",
          },
          {
            name: "Cable TV",
            href: "/dashboard/product/subscribe-cable-tv",
          },
          {
            name: "Betting",
            href: "/dashboard/product/betting",
          },
        ],
      },
      {
        icon: (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_8107_12114)">
              <path
                d="M17.6752 13.2427C17.145 14.4964 16.3158 15.6012 15.2601 16.4605C14.2043 17.3197 12.9541 17.9072 11.6189 18.1717C10.2836 18.4362 8.90386 18.3695 7.60029 17.9775C6.29673 17.5856 5.10903 16.8803 4.14102 15.9233C3.17302 14.9662 2.45418 13.7867 2.04737 12.4877C1.64055 11.1887 1.55814 9.80978 1.80734 8.47157C2.05653 7.13336 2.62975 5.87656 3.47688 4.81107C4.324 3.74557 5.41924 2.90381 6.66684 2.35938"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M18.3333 10.0013C18.3333 8.90695 18.1178 7.82332 17.699 6.81227C17.2802 5.80123 16.6664 4.88257 15.8926 4.10875C15.1187 3.33492 14.2001 2.7211 13.189 2.30231C12.178 1.88352 11.0943 1.66797 10 1.66797V10.0013H18.3333Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_8107_12114">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        ),
        name: "Report",
        hasChildren: true,
        href: "",
        children: [
          {
            name: "Main Wallet",
            href: "/dashboard/report/main-wallet",
          },
          {
            name: "Commision Wallet",
            href: "/dashboard/report/commision-wallet",
          },
          {
            name: "Pending Transaction",
            href: "/dashboard/report/pending-transaction",
          },
        ],
      },
      {
        icon: (
          <svg
            width="22"
            height="20"
            viewBox="0 0 22 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.1154 9.58579C7.52173 9.96086 7.75 10.4696 7.75 11V7C7.75 6.46957 7.97827 5.96086 8.3846 5.58579C8.79093 5.21071 9.34203 5 9.91667 5H12.0833C12.658 5 13.2091 5.21071 13.6154 5.58579C14.0217 5.96086 14.25 6.46957 14.25 7V3C14.25 2.46957 14.4783 1.96086 14.8846 1.58579C15.2909 1.21071 15.842 1 16.4167 1H18.5833C19.158 1 19.7091 1.21071 20.1154 1.58579C20.5217 1.96086 20.75 2.46957 20.75 3V17C20.75 17.5304 20.5217 18.0391 20.1154 18.4142C19.7091 18.7893 19.158 19 18.5833 19H16.4167C15.842 19 15.2909 18.7893 14.8846 18.4142C14.4783 18.0391 14.25 17.5304 14.25 17C14.25 17.5304 14.0217 18.0391 13.6154 18.4142C13.2091 18.7893 12.658 19 12.0833 19H9.91667C9.34203 19 8.79093 18.7893 8.3846 18.4142C7.97827 18.0391 7.75 17.5304 7.75 17C7.75 17.5304 7.52173 18.0391 7.1154 18.4142C6.70907 18.7893 6.15797 19 5.58333 19H3.41667C2.84203 19 2.29093 18.7893 1.8846 18.4142C1.47827 18.0391 1.25 17.5304 1.25 17V11C1.25 10.4696 1.47827 9.96086 1.8846 9.58579C2.29093 9.21071 2.84203 9 3.41667 9H5.58333C6.15797 9 6.70907 9.21071 7.1154 9.58579Z"
              fill="white"
            />
            <path
              d="M7.75 17V11C7.75 10.4696 7.52173 9.96086 7.1154 9.58579C6.70907 9.21071 6.15797 9 5.58333 9H3.41667C2.84203 9 2.29093 9.21071 1.8846 9.58579C1.47827 9.96086 1.25 10.4696 1.25 11V17C1.25 17.5304 1.47827 18.0391 1.8846 18.4142C2.29093 18.7893 2.84203 19 3.41667 19H5.58333C6.15797 19 6.70907 18.7893 7.1154 18.4142C7.52173 18.0391 7.75 17.5304 7.75 17ZM7.75 17V7C7.75 6.46957 7.97827 5.96086 8.3846 5.58579C8.79093 5.21071 9.34203 5 9.91667 5H12.0833C12.658 5 13.2091 5.21071 13.6154 5.58579C14.0217 5.96086 14.25 6.46957 14.25 7V17M7.75 17C7.75 17.5304 7.97827 18.0391 8.3846 18.4142C8.79093 18.7893 9.34203 19 9.91667 19H12.0833C12.658 19 13.2091 18.7893 13.6154 18.4142C14.0217 18.0391 14.25 17.5304 14.25 17M14.25 17V3C14.25 2.46957 14.4783 1.96086 14.8846 1.58579C15.2909 1.21071 15.842 1 16.4167 1H18.5833C19.158 1 19.7091 1.21071 20.1154 1.58579C20.5217 1.96086 20.75 2.46957 20.75 3V17C20.75 17.5304 20.5217 18.0391 20.1154 18.4142C19.7091 18.7893 19.158 19 18.5833 19H16.4167C15.842 19 15.2909 18.7893 14.8846 18.4142C14.4783 18.0391 14.25 17.5304 14.25 17Z"
              stroke={
                location.pathname === "/dashboard/performance"
                  ? "#8D0C9199"
                  : "#25233A"
              }
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
        name: "Performance",
        hasChildren: false,
        href: "/dashboard/performance",
        isDashboard: true,
      },
      {
        icon: <FiSettings />,
        name: "Settings",
        hasChildren: true,
        href: "",
        children: [
          {
            name: "Account Limit",
            href: "/dashboard/settings/account-limit",
          },
          {
            name: "Change Password",
            href: "/dashboard/settings/change-REMOVED",
          },
          {
            name: "Profile",
            href: "/dashboard/settings/profile",
          },
          {
            name: "Reset PIN",
            href: "/dashboard/settings/reset-pin",
          },
          {
            name: "Support",
            href: "/dashboard/settings/support",
          },
        ],
      },
    ],
  };

  return URLValues;
};
